import IService from '../IService';
import app from 'app';

export default IService.extend({
  options: {},

  initialize: function () {
    this.$ajax = null;
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  post(assetUUID) {
    return new Promise((resolve, reject) => {
      this.$ajax = $.ajax({
        url: serverProfile.apiUrl + `/api/v1/assets/${assetUUID}/videoScenes`,
        type: 'POST',
        timeout: app.TIME.MINUTE,

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        success: () => {
          resolve();
        },
      }).always(() => {
        this.$ajax = null;
      });
    });
  },

  get(assetUUID) {
    return new Promise((resolve, reject) => {
      this.$ajax = $.ajax({
        url: serverProfile.apiUrl + `/api/v1/assets/${assetUUID}/videoScenes`,
        type: 'GET',
        timeout: app.TIME.MINUTE,

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        success: (response) => {
          let rv = [];

          if (!_.isEmpty(response.videoScenes)) {
            rv = response.videoScenes;

            _.each(rv, (scene, i) => {
              scene.guid = app.guid();

              if (scene.startTime !== 0) {
                // add frame to following scenes,
                // it occur that startTime of scene actually encloses scene
                scene.startTime += app.TIME.FRAME._60 * 5;
                if (i < rv.length - 1) {
                  scene.duration -= app.TIME.FRAME._60 * 5;
                }
              }
              scene.startTime = app.sfp(scene.startTime, 1e3);
              scene.duration = app.sfp(scene.duration, 1e3);
            });

            rv = _.filter(
              rv,
              (scene) => scene.duration >= app.TIME.MIN_FRAGMENT_DURATION
            );
          }

          resolve(rv);
        },
      }).always(() => {
        this.$ajax = null;
      });
    });
  },
});
